import { Translatable, TranslateProperty } from '../../../core/helper/translatables';
import { ModelBase } from '../../../core/model/model-base';
import { B2CSubscriptionState, B2CSubscriptionStateToString } from '../const/enum-b2c';
import { B2CSubscriptionContact } from './b2c-subscription-contact';
import { B2CSubscriptionContactEvent } from './b2c-subscription-contact-event';
import { B2CSubscriptionIdentity } from './b2c-subscription-identity';
import { B2CSubscriptionImportEvent } from './b2c-subscription-import-event';

export class B2CSubscription extends ModelBase {
  constructor() {
    super();
    TranslateProperty(this as B2CSubscription, 'state', B2CSubscriptionStateToString);
  }

  identity: B2CSubscriptionIdentity;

  state: Translatable<B2CSubscriptionState>;
  stateChangedDate: Date;

  contacts: B2CSubscriptionContact[];

  contactEvents: B2CSubscriptionContactEvent[];
  importEvents: B2CSubscriptionImportEvent[];

  get isActive(): boolean {
    return this.state == B2CSubscriptionState.Active;
  }

  toString(culture?: string): string {
    return this.identity.toString(culture);
  }

  public static Map(source: B2CSubscription): B2CSubscription {
    if (!source) {
      return null;
    }
    const obj = Object.assign(new B2CSubscription(), source);
    obj.identity = B2CSubscriptionIdentity.Map(source.identity);
    obj.contacts = source.contacts?.map(B2CSubscriptionContact.Map) || [];
    obj.contactEvents = source.contactEvents?.map(B2CSubscriptionContactEvent.Map) || [];
    obj.importEvents = source.importEvents?.map(B2CSubscriptionImportEvent.Map) || [];
    return obj;
  }
}

// TODO: can be useful later - return an array of these
//export class B2CSubscriptionCompanyModel extends ModelBase {
//  constructor() {
//    super();
//  }

//  name: string;
//  number: number;
//  organizationNo: string;

//  public static Map(source: B2CSubscriptionCompanyModel): B2CSubscriptionCompanyModel {
//    if (!source) {
//      return null;
//    }
//    return Object.assign(new B2CSubscriptionCompanyModel(), source);
//  }
//}
